import { sub } from 'date-fns';

import { AbsoluteTimeRange, TimeRange } from './TimeRange.types';

export class TimeRangeUtils {
  static convertToAbsolute(range: TimeRange, baseTimestamp = Date.now()): AbsoluteTimeRange {
    if (!range.unit) {
      return range;
    }

    const from = sub(baseTimestamp, { [range.unit]: range.offset }).getTime();
    const to = baseTimestamp;

    return {
      from: Math.min(from, to),
      to: Math.max(from, to),
    };
  }

  static serialize(value: TimeRange): string {
    return JSON.stringify(value);
  }

  static deserialize(value: string): TimeRange {
    return JSON.parse(value);
  }

  static areEqual(timeRange1: TimeRange, timeRange2: TimeRange): boolean {
    return TimeRangeUtils.serialize(timeRange1) === TimeRangeUtils.serialize(timeRange2);
  }
}
